export type Colors = {
	BACKGROUND: string;
	BACKGROUND_SECONDARY: string;
	BACKGROUND_DARK: string;
	PAPER: string;
	PRIMARY: string;
	SECONDARY: string;
	font_main: string;
	font_status: string;
	font_light: string;
	TABLE_ROW: string;
	TABLE_ROW_HOVER: string;
	RETURNED: string;
	DISCOUNT: string;
	CORRECTION: string;
	WARNING: string;
	SUCCESS: string;
	ERROR: string;
};

export type ThemeName = 'light' | 'dark' | 'light_gray';

export const COLORS_THEMES: Record<ThemeName, Colors> = {
	light: {
		BACKGROUND: '#03629314',
		BACKGROUND_SECONDARY: '#03629340',
		BACKGROUND_DARK: '#004468',
		PAPER: '#ffffff',
		PRIMARY: '#016193',
		SECONDARY: '#cddee8',
		font_main: '#000000c0',
		font_status: '#000000a0',
		font_light: '#000000',
		TABLE_ROW: '#03629314',
		TABLE_ROW_HOVER: '#03629338!important',
		RETURNED: '#FFD6A7',
		DISCOUNT: '#ffeb78',
		CORRECTION: '#e0e782',
		WARNING: 'warning.light',
		SUCCESS: 'success.light',
		ERROR: 'error.light',
	},
	dark: {
		BACKGROUND: '#111111',
		BACKGROUND_SECONDARY: '#053c59',
		BACKGROUND_DARK: '#004468',
		PAPER: '#001825',
		PRIMARY: '#016193',
		SECONDARY: '#0A3D62',
		font_main: '#ffffffd0',
		font_status: '#ffffffa0',
		font_light: '#ffffff',
		TABLE_ROW: '#03629314',
		TABLE_ROW_HOVER: '#03629338!important',
		RETURNED: '#FFD6A7',
		DISCOUNT: '#ffeb78',
		CORRECTION: '#e0e782',
		WARNING: 'warning.light',
		SUCCESS: 'success.light',
		ERROR: 'error.light',
	},
	light_gray: {
		BACKGROUND: '#eaeaea',
		BACKGROUND_SECONDARY: '#c3c6c8',
		BACKGROUND_DARK: '#5f6a6a',
		PAPER: '#ffffff',
		PRIMARY: '#5f6a6a',
		SECONDARY: '#9aa0a6',
		font_main: '#000000c0',
		font_status: '#000000a0',
		font_light: '#000000',
		TABLE_ROW: '#f0f0f0',
		TABLE_ROW_HOVER: '#e5e5e5!important',
		RETURNED: '#FFD6A7',
		DISCOUNT: '#ffeb78',
		CORRECTION: '#e0e782',
		WARNING: 'warning.light',
		SUCCESS: 'success.light',
		ERROR: 'error.light',
	},
};

const getSavedTheme = (): ThemeName => {
	try {
		if (typeof window !== 'undefined') {
			const saved = localStorage.getItem('theme') as ThemeName | null;
			return saved === 'dark' || saved === 'light' || saved === 'light_gray' ? saved : 'light';
		}
	} catch (_) {
		// ignore read errors and fallback to default theme
	}
	return 'light';
};

export const COLORS: Colors = COLORS_THEMES[getSavedTheme()];

export const setTheme = (theme: ThemeName): void => {
	const nextTheme: ThemeName = theme === 'dark' || theme === 'light_gray' ? theme : 'light';
	try {
		if (typeof window !== 'undefined') {
			localStorage.setItem('theme', nextTheme);
		}
	} catch (_) {
		// ignore write errors
	}
};

export const getTheme = (): ThemeName => getSavedTheme();

export type ColorKey = keyof Colors;
export type ColorValue = Colors[ColorKey];
